import {hasAccountData} from "./account";

export function getUserId(accessToken: any): string {
	return (accessToken && accessToken.decoded.sub) || null;
}

export function getLoginName(accountData) {
	return hasAccountData(accountData) && accountData.login;
}
